<template>
  <v-menu v-model="menu">
    <template v-slot:activator="{ on, attrs }">
      <v-autocomplete
        color="primary"
        hide-no-data
        v-model="dishCategorySelected"
        :clearable="!unclearable"
        :items="dishCategoriesSelected"
        :loading="dishCategoriesLoading"
        :search-input.sync="dishCategoriesSearch"
        item-text="name"
        item-value="id"
        :label="noLabel ? '' : $t('DishCategory.title')"
        :error-messages="errorMessages"
        return-object
        v-bind="attrs"
        v-on="on"
      >
        <template v-slot:append>
          <v-icon
            style="height: 24px; width: 24px"
            :color="menu ? 'primary' : ''"
            @click.stop="menu = !menu"
          >
            {{ menu ? "fa-caret-up" : "fa-caret-down" }}
          </v-icon>
        </template>
      </v-autocomplete>
    </template>
    <div style="max-height: 304px">
      <v-sheet>
        <v-treeview
          v-model="tree"
          :items="dishCategories"
          :search="dishCategoriesSearch"
          :filter="categoriesFilter"
          :active.sync="dishCategoriesSelected"
          selection-type="independent"
          item-key="id"
          item-text="name"
          item-children="categories"
          open-all
          hoverable
          activatable
          return-object
        />
      </v-sheet>
    </div>
  </v-menu>
</template>

<style scoped>
.v-list {
  display: none !important;
}
.v-menu__content {
  margin-top: 45px;
}
</style>

<script>
import DishCategories from "@/api/dish_categories";

export default {
  name: "SearcherDishCategory",

  props: {
    value: Object,
    noLabel: Boolean,
    unclearable: Boolean,
    errorMessages: Array,
  },

  computed: {
    categoriesFilter() {
      return (item, search, textKey) =>
        this.dishCategorySelected &&
        search == this.dishCategorySelected.name
          ? true
          : item[textKey].indexOf(search) > -1;
    },
  },

  created() {
    this.getDishCategoriesFromAPI();
  },

  data: () => ({
    menu: false,
    tree: [],
    dishCategories: [],
    dishCategoriesLoading: false,
    dishCategoriesSearch: "",
    dishCategoriesSelected: [],
    dishCategorySelected: null,
  }),

  methods: {
    getDishCategoriesFromAPI() {
      this.dishCategoriesLoading = true;
      DishCategories.tree()
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.dishCategories = response.data.categories;
              if (this.$route.query.category_id) {
                this.dishCategorySelected = this.$commonUtils.breadthQuery(
                  this.dishCategories,
                  this.$route.query.category_id,
                  "categories"
                );
              }
            }
            this.dishCategoriesLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.dishCategoriesLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dishCategoriesSelected = this.value ? [this.value] : [];
      },
    },
    dishCategoriesSelected: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dishCategorySelected =
          this.dishCategoriesSelected && this.dishCategoriesSelected[0]
            ? this.dishCategoriesSelected[0]
            : null;
      },
    },
    dishCategorySelected: {
      handler() {
        this.dishCategoriesSelected = this.dishCategorySelected
          ? [this.dishCategorySelected]
          : [];
        this.$emit("input", this.dishCategorySelected);
      },
    },
    dishCategoriesSearch: {
      handler() {
        if (!this.unclearable && !this.dishCategoriesSearch)
          this.dishCategoriesSelected = [];
      },
    },
  },
};
</script>
